import { Div, P } from '@kizi/core-components';
import { Accordion } from '@kizi/shared-components';
import React from 'react';
import { Arrow } from '..';

interface ContractSwitchFaqProps {
  items: ContractSwitchFaqItem[];
}

export interface ContractSwitchFaqItem {
  content: string;
  label: string;
}

export const innerAccordionItemLabel =
  (label: React.ReactNode) => (isOpen: boolean) => {
    return (
      <Div display="flex" justifyContent="space-between">
        <P maxWidth="90%" variant="footnoteImportant">
          {label}
        </P>
        <Arrow isOpen={isOpen} />
      </Div>
    );
  };

export const ContractSwitchFaq = ({ items }: ContractSwitchFaqProps) => {
  const faqItems = items.map(({ content, label }) => {
    return {
      label: innerAccordionItemLabel(label),
      content: <P variant="footnoteRegular">{content}</P>,
    };
  });

  return <Accordion items={faqItems} variant="innerProductTabAccordion" />;
};
